<template>
  <b-modal
    id="filter-by-category-modal"
    hide-footer
    size="sm"
  >
    <b-card no-body>
      <b-card-body v-if="label">
        <b-card-sub-title v-if="title">
          {{ title }}
        </b-card-sub-title>
        {{ label }}
      </b-card-body>
      <b-list-group flush>
        <b-list-group-item
          v-for="option in options"
          :key="`filter-bubbles-category-by-${option.value}`"
          button
          :disabled="filterByLocationActive || !(options.length > 1)"
          :active="selectedCategory===option.value"
          @click="selectedCategory=option.value"
        >
          {{ option.text }}
        </b-list-group-item>
      </b-list-group>
    </b-card>
  </b-modal>
</template>

<script lang="ts">

import Component from 'vue-class-component'

import FilterByCategoryMixin from '@/mixins/FilterByCategoryMixin'

@Component
export default class FilterByCategoryModal extends FilterByCategoryMixin {}

</script>
